import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider, ProtectedRoute } from "@/context/AuthContext";
import { Navigation } from "@/components/Navigation";
import { LoginPage } from "@/pages/LoginPage";
import { Dashboard } from "@/pages/Dashboard";
import { Applications } from "@/pages/Applications";
import { Afslattur } from "@/pages/Afslattur";
import { LoanCalculator } from "@/pages/LoanCalculator";
import { SettingsPage } from "@/pages/SettingsPage";
import { PaymentSchedule } from "@/pages/PaymentSchedule";
import { VanskilDetails } from "@/pages/VanskilDetails";
import { NaestiManudurDetails } from "@/pages/NaestiManudurDetails";
import { UtistandandiSkuldDetails } from "@/pages/UtistandandiSkuldDetails";
import { OgreidirReikningarDetails } from "@/pages/OgreidirReikningarDetails";
import { Skyrslu } from "@/pages/Skyrslu";
import { AfsolPage } from "@/pages/AfsolPage";
import { AfsolFormPage } from "@/pages/AfsolFormPage";
import { AfsolPrintPreviewPage } from "@/pages/AfsolPrintPreviewPage";
import { Customers } from "@/pages/Customers";
import { Invoices } from "@/pages/Invoices";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <AuthProvider>
      <div className="min-h-screen bg-gray-50">
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/afsol/:afsalId/print/:mode" element={
              <ProtectedRoute>
                <AfsolPrintPreviewPage />
                <Toaster richColors position="top-right" />
              </ProtectedRoute>
            } />
            
            <Route path="/*" element={
              <ProtectedRoute>
                <Navigation />
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/vidskiptamenn" element={<Customers />} />
                  <Route path="/reikningar" element={<Invoices />} />
                  <Route path="/applications" element={<Applications />} />
                  <Route path="/afslattur" element={<Afslattur />} />
                  <Route path="/calculator" element={<LoanCalculator />} />
                  <Route path="/settings" element={<SettingsPage />} />
                  <Route path="/greidslur/:loanId" element={<PaymentSchedule />} />
                  <Route path="/vanskil" element={<VanskilDetails />} />
                  <Route path="/naesti-manudur" element={<NaestiManudurDetails />} />
                  <Route path="/utistandandi-skuld" element={<UtistandandiSkuldDetails />} />
                  <Route path="/ogreiddir-reikningar" element={<OgreidirReikningarDetails />} />
                  <Route path="/skyrslu" element={<Skyrslu />} />
                  <Route path="/afsol/new" element={<AfsolFormPage />} />
                  <Route path="/afsol/:afsalId" element={<AfsolFormPage />} />
                  <Route path="/afsol" element={<AfsolPage />} />
                </Routes>
                
                <footer className="bg-slate-800 text-white py-6 mt-12">
                  <div className="max-w-7xl mx-auto px-4">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                      <div>
                        <h3 className="font-bold text-lg mb-2">FONDO ehf.</h3>
                        <p className="text-gray-300 text-sm">
                          Kennitala: 521216-1310<br />
                          Krokháls 7<br />
                          110 Reykjavík
                        </p>
                      </div>
                      <div>
                        <h3 className="font-bold text-lg mb-2">Þjónusta</h3>
                        <p className="text-gray-300 text-sm">
                          Persónuleg fjármálaþjónusta<br />
                          Lánastýring<br />
                          Fjármálaráðgjöf
                        </p>
                      </div>
                      <div>
                        <h3 className="font-bold text-lg mb-2">Samband</h3>
                        <p className="text-gray-300 text-sm">
                          Netfang: info@fondo.is<br />
                        </p>
                      </div>
                    </div>
                    <div className="border-t border-gray-700 mt-6 pt-4 text-center text-gray-400 text-sm">
                      &copy; 2025 FONDO ehf. Öll réttindi áskilin.
                    </div>
                  </div>
                </footer>

                <Toaster richColors position="top-right" />
              </ProtectedRoute>
            } />
          </Routes>
        </BrowserRouter>
        <div id="print-area" className="hidden print:block" style={{fontFamily: 'Times, serif', fontSize: '11px'}}></div>
      </div>
    </AuthProvider>
  );
}

export default App;
